var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"shipped-button",attrs:{"title":"Mark As Shipped"}},[_c('i',{staticClass:"fa fa-truck truck-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }